<div *ngIf="spinnerVisible">
  <div class="spinner-overlay">
    <div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </div>
</div>
